import { Seo } from '@/components/Seo';
import { ContentPage, P } from '@/components/PublicLayout';
import { useLang, useT } from '@/i18n/LanguageContext';
import { statementContent } from '@/i18n/content/statement';
import { pathFor } from '@/i18n/routes';
import off1 from '@/assets/off1.webp.asset.json';
import off2 from '@/assets/off2.webp.asset.json';
import off3 from '@/assets/off3.webp.asset.json';
import off4 from '@/assets/off4.webp.asset.json';

const IMAGES = [off1.url, off2.url, off3.url, off4.url];

/** Paragraph index before which a floated square figure is rendered. */
const FIGURE_BEFORE: Record<number, number> = {
  1: 0,
  5: 1,
  6: 2,
  9: 3,
};

export default function Statement() {
  const lang = useLang();
  const t = useT(statementContent);
  const alts = t.figureAlts;

  const renderFigure = (index: number) => {
    const right = index % 2 === 0;
    return (
      <figure
        className={
          right
            ? 'mb-6 sm:float-right sm:w-1/2 sm:ml-8'
            : 'mb-6 sm:float-left sm:w-1/2 sm:mr-8'
        }
      >
        <img
          src={IMAGES[index]}
          alt={alts[index]}
          loading="lazy"
          className="w-full aspect-square object-cover rounded-sm"
        />
      </figure>
    );
  };

  return (
    <>
      <Seo
        title={t.seoTitle}
        description={t.seoDescription}
        path={pathFor('statement', lang)}
      />
      <ContentPage title={t.title} intro={t.intro}>
        {t.paragraphs.map((p, i) => (
          <div key={i} className="contents">
            {FIGURE_BEFORE[i] !== undefined && renderFigure(FIGURE_BEFORE[i])}
            {typeof p === 'string' ? (
              <P>{p}</P>
            ) : 'segments' in p ? (
              <P>
                {p.segments.map((s, j) =>
                  'em' in s ? <em key={j}>{s.em}</em> : <span key={j}>{s.text}</span>
                )}
              </P>
            ) : (
              <P>
                <em>{p.em}</em>
              </P>
            )}
          </div>
        ))}
        <div className="clear-both" />
      </ContentPage>
    </>
  );
}
